import Alert from '@customink/pigment-react/lib/components/Alert';

import { CustomerCareLink } from '@/components/CustomerCareLink';

export default function PricingError({}) {
  return (
    <Alert severity="info">
      We’ve encountered a pricing error for this design. Please call us at{' '}
      <CustomerCareLink /> for assistance.
    </Alert>
  );
}
